module.exports = __webpack_public_path__ + "img/collapse-down.fc06a399.svg";